export default {
  cms: {
    baseUrl: process.env.CMS_BASE_URL || 'https://cms.imoli.dev',
    privateBaseUrl: process.env.CMS_PRIVATE_BASE_URL || 'http://localhost:8855'
  }
}
